import React from 'react';
import Button from '../../../button/button';

import styles from './csv-uploader-modal-footer.module.scss';

interface ButtonProps {
	text: string;
	onClick: () => void;
	disabled?: boolean;
	loading?: boolean;
}

interface CSVUploaderModalFooterProps {
	okButton: ButtonProps;
	cancelButton: ButtonProps;
}

export const CSVUploaderModalFooter = ({ okButton, cancelButton }: CSVUploaderModalFooterProps) => {
	return (
		<div className={styles.buttonsContainer}>
			<Button onClick={cancelButton.onClick} disabled={cancelButton.disabled} type="link">
				{cancelButton.text}
			</Button>
			<Button onClick={okButton.onClick} disabled={okButton.disabled} loading={okButton.loading} type="primary">
				{okButton.text}
			</Button>
		</div>
	);
};
